import React, { useState, useEffect, PropsWithChildren } from 'react'
import { SportContext } from '../contexts'
import { Sport } from '../types'
import { listSports } from '../services'

export const SportsProvider = ({ children }: PropsWithChildren) => {
  const [sports, setSports] = useState<Sport[]>([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    listSports()
      .then(({ data }) => setSports(data))
      .finally(() => setIsLoaded(true))
  }, [])

  return (
    <SportContext.Provider
      value={{
        sports,
        isLoaded
      }}>
      {children}
    </SportContext.Provider>
  )
}
